export default ".modal-dialog {\n  width: 600px;\n  max-height: 600px;\n}\n\n.btn-primary.pull-right {\n  margin-left: 10px;\n}";